var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CommonHeader',{staticClass:"common",class:{ 'style-index': _vm.indexFlag, 'style-common': !_vm.indexFlag }}),_c('router-view'),_c('CommonFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }